<div class="flex flex-row flex-gap-16-8 align-items-center">
  @if (filterDefinition$ | async; as filterDefinition) {
    @for (filter of filterDefinition.filters; track filter.name) {
      @if (filter.type === FilterItemType.Select || filter.type === FilterItemType.MultiSelect) {
        <div class="select-content-width">
          @let map = filterSelectionMap.get(filter.name);
          <shared-select-with-search
            selectClass="pointee-mat-select"
            [attr.data-testid]="'filter-' + filter.name + '-select'"
            [multiple]="filter.type === FilterItemType.MultiSelect"
            [items]="map.items"
            [fixedItems]="map.fixedItems"
            [selection]="map.selection"
            [defaultValue]="map.defaultValue"
            [placeholder]="filter.placeholder"
            [disabled]="disabled"
            (selectionChange)="onFilterValueChanged($event, filter)"
            (selectionEnd)="onFilterClosed($event, filter)"
          />
        </div>
        @if (filter.getTooltip) {
          <ng-container *ngrxLet="filter.getTooltip() as tooltipMsg">
            @if (tooltipMsg) {
              <span class="filter-info">
                <shared-info-icon [tooltip]="tooltipMsg" />
              </span>
            }
          </ng-container>
        }
      }
    }
    @if (canClearAllFilters()) {
      <button class="btn btn-link" (click)="clearFilters()">
        <svg-icon key="close" [fontSize]="10"/><b>Clear filters</b>
      </button>
    }
  } @else {
    <shared-local-dot-loader />
  }
</div>
